import { render, staticRenderFns } from "./NewTicketDialog.vue?vue&type=template&id=082008fa&scoped=true&"
import script from "./NewTicketDialog.vue?vue&type=script&lang=js&"
export * from "./NewTicketDialog.vue?vue&type=script&lang=js&"
import style0 from "./NewTicketDialog.vue?vue&type=style&index=0&id=082008fa&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "082008fa",
  null
  
)

export default component.exports